import PropTypes from 'prop-types'
import React from 'react'
import classNames from 'classnames'
import Base from './BaseContainer'
import { connect } from 'react-redux'
import { reset } from 'redux-form'
import { fetchAccountAction, fetchForgottenAccountAction, fetchNewAccountAction } from '../services/ws/AuthWS'
import { fetchUsersAction } from '../services/ws/AdminWS'
import LoginComponent from '../components/Login/Login'
import styles from '../styles/styles.module.scss'

class Login extends Base {

  constructor () {
    super()
    this._bind('_handleSubmit', '_handleRegisterClick', '_handleForgotClick', '_getParameterByName')
    this.state = {
      viewState: 'login',
      infos: [],
    }
  }

  UNSAFE_componentWillMount () {
    if (window.location.search.length) {
      let splitSearch = window.location.search.split('=')
      splitSearch.map((string, index) => {
        splitSearch[index] = string.replace('&username', '').replace('%40', '@')
        return null
      })
      this.setState({
        viewState: window.location.pathname === '/activate' ? 'create' : 'reinit',
        infos: ['code', this._getParameterByName('code'), this._getParameterByName('username')],
      })
    }
  }

  _getParameterByName (name, url) {
    if (!url) {
      url = window.location.href.replace('%40', '@')
    }
    // eslint-disable-next-line no-useless-escape
    name = name.replace(/[\[\]]/g, '\\$&')
    let regex = new RegExp('[?&]' + name + '(=([^&#]*)|&|#|$)')
    let results = regex.exec(url)
    if (!results) return null
    if (!results[2]) return ''
    return decodeURIComponent(results[2].replace(/\+/g, ' '))
  }

  _handleSubmit (data) {
    this.props.dispatch(reset('sign-up-form'))
    if (this.state.viewState === 'create' || this.state.viewState === 'reinit') {
      let user = {
        username: this.state.infos[2],
        code: this.state.infos[1],
        newPassword: data.password,
        password: data.password,
        userName: this.state.infos[2],
      }
      this.props.changePassword(user)
      // this.props.history.push(Constants.RoutesConstants.root)
    } else {
      if (data.userName && data.password &&
        !data.firstName && !data.lastName && !data.email && !data.confirmPassword) {
        this.props.connectUser(data)
      } else if (data.userName && data.password &&
        data.firstName && data.lastName && data.email && data.confirmPassword) {
        this.props.registerUser(data)
      } else {
        this.props.forgottenPassword(data)
        this.setState({viewState: 'login'})
      }
    }
  }

  _handleRegisterClick () {
    if (this.state.viewState === 'login') {
      this.setState({viewState: 'register'})
    } else {
      this.setState({viewState: 'login'})
    }

    this.props.dispatch(reset('sign-up-form'))
  }

  _handleForgotClick () {
    this.setState({viewState: 'forgot'})
    this.props.dispatch(reset('sign-up-form'))
  }

  render () {
    return (
      <div>
      <LoginComponent onSubmit={this._handleSubmit}
        onClick={this._handleRegisterClick}
        onForgotClick={this._handleForgotClick}
        currentView={this.state.viewState}
        emailCreation={this.state.infos.length === 3 ? this.state.infos[2] : null}/>
        <div className={classNames(styles.FOSSLink, styles.noBG)}>
          <a href='/credits.html' target='_blank'>credits</a>
          <div>|</div>
          <a href='https://swizi.slack.com/signup' target='_blank' rel="noopener noreferrer">slack</a>
        </div>
      </div>
    )
  }

}

Login.propTypes = {
  dispatch: PropTypes.func.isRequired,
  user: PropTypes.object,
  register: PropTypes.bool,
  forgot: PropTypes.bool,
  registerUser: PropTypes.func.isRequired,
  connectUser: PropTypes.func.isRequired,
  forgottenPassword: PropTypes.func.isRequired,
  datas: PropTypes.object,
  changePassword: PropTypes.func.isRequired,
}

const mapStateToProps = ({ authWS: { user, register, forgot } }) => ({
  user,
  register,
  forgot,
})

const mapDispatchToProps = (dispatch) => ({
  dispatch: dispatch,
  registerUser (datas) {
    fetchNewAccountAction(dispatch, datas).fetchNewAccount()
  },
  connectUser (datas) {
    fetchAccountAction(dispatch, datas).fetchAccount()
  },
  forgottenPassword (datas) {
    fetchForgottenAccountAction(dispatch, datas).fetchForgottenAccount()
  },
  changePassword (datas) {
    fetchUsersAction(dispatch, datas).changePassword()
  },
})

export default connect(mapStateToProps, mapDispatchToProps)(Login)
